export const getRelativePath = (path = '', basePath = ''): string => {
  const relativePath = path.replace(`${basePath}`, '');
  if (relativePath[0] === '/') return relativePath.substring(1);

  return relativePath;
};
